import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CrossCircledIcon } from "@radix-ui/react-icons";
import { iconSize } from "../../../../../../core/design-system/index.js";
import { Container } from "../../../../components/basic.js";
import { Text } from "../../../../components/text.js";
export function ErrorText(props) {
    return (_jsxs(Container, { gap: "xxs", flex: "column", children: [_jsxs(Container, { flex: "row", gap: "xxs", center: "both", color: "danger", children: [_jsx(CrossCircledIcon, { width: iconSize.sm, height: iconSize.sm }), _jsx(Text, { color: "danger", size: "sm", children: props.title })] }), _jsx(Text, { center: true, size: "xs", children: props.message })] }));
}
//# sourceMappingURL=ErrorText.js.map